module.exports = __webpack_public_path__ + "static/media/AI-Chip-Illustrated-SVG-Icon.c9942f5a.svg";